import { useMutation } from '@apollo/client'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

const CREATE_RAW_ORDERS_EXPORT = atlas`#graphql
  mutation CreateRawOrdersExport {
    createRawOrdersExport {
        taskId
    }
  }
`

export const useDownloadRawData = () => {
  const [downloadRawData] = useMutation(CREATE_RAW_ORDERS_EXPORT, {
    client: atlasClient,
  })

  return downloadRawData
}
